import * as React from "react";
import { Link } from "react-router-dom";

import Button from "@material-ui/core/Button/Button";

import { DownloadPDFButton, ResumePaperworkButton } from "../../..";

/**
 * @return {null}
 */
function PrimaryActionButton({
  pathname,
  portfolio,
  household,
  adminView,
  custodian
}) {
  const householdId =
    household.currentHousehold && household.currentHousehold.id;
  const style = {
    fontSize: 12,
    textTransform: "none",
    marginRight: 16,
  };
  if (adminView) {
    return (
      <React.Fragment>
        <Link
          to={`/Portal/admin/household/${householdId}/portfolio/${portfolio.uuid}`}
        >
          <Button
            style={style}
            variant="outlined"
            color="primary"
            size={"small"}
            data-cy="household.portfolio.view"
          >
            View
          </Button>
        </Link>
        <DownloadPDFButton
          portfolioIds={[portfolio.uuid]}
          householdId={householdId}
        />
        {
          portfolio.onboardStatus === 'forms-generated' &&
          custodian &&
          custodian.onboardingRules.digitalOnboardingEnabled && !portfolio.DoSessionId &&
          <ResumePaperworkButton portfolioId={portfolio.uuid} />
        }
      </React.Fragment>
    );
  }
  // TODO: A portfolio's risk can never be 0 now since it'll now be based on
  // the household risk.
  if (portfolio.metadata.risk === 0) {
    return adminView ? null : (
      <Link to={`/Portal/household/${householdId}/risk`}>
        <Button
          style={style}
          variant="contained"
          color={"secondary"}
          size={"small"}
        >
          Loss Simulator
        </Button>
      </Link>
    );
  }
  if (!portfolio.metadata.scenario) {
    return adminView ? null : (
      <Link to={`/Portal/household/${householdId}/portfolio/${portfolio.uuid}`}>
        <Button
          style={style}
          variant="contained"
          color={"secondary"}
          size={"small"}
        >
          See Portfolio
        </Button>
      </Link>
    );
  }

  return (
    <React.Fragment>
      <Link to={`/Portal/household/${householdId}/summary/${portfolio.uuid}`}>
        <Button style={style} variant="outlined" color="primary" size={"small"} data-cy="household.portfolio.view">
          View
        </Button>
      </Link>
    </React.Fragment>
  );
}

export default PrimaryActionButton;



// WEBPACK FOOTER //
// ./src/containers/HouseholdDetail/components/PortfolioTable/components/PrimaryActionButton/index.jsx